import { render } from '@wordpress/element';

import './themes/woa/globalStyle.scss';
import Testimonial from './widgets/FrontComponent/Testimonial';
// import TestimonialD2 from './widgets/FrontComponent/TestimonialD2';
// import api from "./api/apiClient";

function renderApp() {
      
    const testimonial_module = document.querySelectorAll('.woa-testimonial-slider');
  
    testimonial_module.forEach(widget => {
      const newElement = document.createElement('div');
      const testimonials = JSON.parse(widget.dataset.testimonials);  
      const settings = JSON.parse(widget.dataset.settings);  
      // console.log(settings);
      newElement.className = 'woa-testimonial-slider-container'; // Add a custom class for identification
      widget.replaceWith(newElement);
    
      // Render the React component into the new container
      render(<Testimonial datapost={testimonials} settings={settings}/>, newElement);
    });	 
}

// Initial render on page load
window.addEventListener("load", renderApp);

// Example: re-render app manually after some event
// window.addEventListener("refreshApp", renderApp);

